package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.ShiftTemplate // Prosty DTO: id, start, end, role
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class CreateShiftTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(
        workplaceId: String,
        name: String, // np. "Poranek Barista" - może być ID lub polem w obiekcie
        startTime: String,
        endTime: String,
        role: String?,
        requiredSkills: List<String>
    ): Result<String> {
        return try {
            val template = ShiftTemplate(
                id = "",
                name = name,
                startTime = startTime,
                endTime = endTime,
                // No role is null ("No Role"), never an empty text.
                role = role?.takeIf { it.isNotBlank() },
                skills = requiredSkills
            )

            workplaceRepository.createShiftTemplate(workplaceId, template)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}